import Toggle from 'components/toggle';
import Tooltip from 'components/tooltip';
import { T } from 'components/translation';

import style from './electronic-id.module.scss';

interface ElectronicIdToggleProps {
  isChecked: boolean;
  canUpdate: boolean;
  onEidToggle: () => void;
  isEnabled: boolean;
}
/* eslint-disable react/prop-types */
export const ElectronicIdToggle: React.FC<ElectronicIdToggleProps> = ({
  isChecked,
  canUpdate,
  onEidToggle,
  isEnabled,
}) => {
  if (!isChecked && !canUpdate) {
    return (
      <Tooltip
        message={
          (
            <T
              _str="Contact your administrator to enable"
              _comment="Tooltip message for enabling an extension when something blocks the action"
            />
          )
        }
        side="right"
      >
        <Toggle
          checked={Boolean(isChecked)}
          className={style.Toggle}
          onChange={onEidToggle}
          disabled
          version="latest"
        />
      </Tooltip>
    );
  }

  return (
    <Toggle
      checked={Boolean(isChecked)}
      className={style.Toggle}
      onChange={onEidToggle}
      disabled={!isEnabled || !canUpdate}
      version="latest"
    />
  );
};
